<template>
  <v-row justify="center">
    <template v-if="type === 'alert'">
      <v-dialog persistent max-width="400" v-model="_show">
        <v-card class="modal-pop">
          <v-card-title class="d-flex alert-title" style="padding: 14px 32px">
            {{ $t(title) }}
          </v-card-title>
          <v-card-text
            class="alert-message"
            style="padding: 6px 32px 40px;white-space:pre-wrap"
          >
            {{ $t(message) }}
          </v-card-text>
          <v-card-actions
            class="d-flex justify-space-between"
            style="padding: 14px 32px;"
          >
            <i-btn
              v-if="useCancel"
              class="btn-type-09"
              text
              @click="close(false)"
            >
              {{ $t(cancelButtonText) }}
            </i-btn>
            <v-spacer />
            <i-btn class="btn-type-04" text @click="close(true)">
              {{ $t(confirmButtonText) }}
            </i-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-else-if="type === 'snackbar'">
      <v-snackbar
        v-model="_show"
        dense
        text
        :timeout="duration"
        :color="snackbarStyle.color"
        style="mb-8"
      >
        <v-icon :color="snackbarStyle.color">{{ snackbarStyle.icon }}</v-icon>
        <strong class="ml-4">{{ $t(message) }}</strong>
      </v-snackbar>
    </template>
  </v-row>
</template>

<script>
import { mdiAlert, mdiCheckCircle, mdiCloseOctagon } from '@mdi/js';
export default {
  props: {
    type: {
      type: String,
      default: 'alert',
    },
    value: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    confirmButtonText: {
      type: String,
      default: '확인',
    },
    cancelButtonText: {
      type: String,
      default: '취소',
    },
    useCancel: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    duration: {
      type: Number,
      default: 3000,
    },
    snackbarType: {
      type: String,
      default: 'info',
    },
  },
  methods: {
    close(isConfirm) {
      this.onClose(isConfirm);
    },
  },
  computed: {
    snackbarStyle() {
      switch (this.snackbarType) {
        case 'danger':
          return { color: 'red accent-2', icon: mdiCloseOctagon };
        case 'warn':
          return { color: 'orange darken-2', icon: mdiAlert };
        default:
          // info
          return { color: 'success', icon: mdiCheckCircle };
      }
    },
    _show: {
      get() {
        return this.value;
      },
      set(v) {
        this.close();
        this.$emit('input', v);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.close-btn {
  cursor: pointer;
  font-size: 18px;
  color: #bdbdbd;
  &:hover {
    color: #424242;
  }
}
.alert-title {
  font-size: 18px !important;
  font-weight: 700 !important;
  color: #363c43 !important;
}
.alert-message {
  border-bottom: 1px solid #d5d8dc;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  letter-spacing: -0.42px;
  color: #363c43 !important;
}
</style>
